var map = {
	"./404.svg": "0VJI",
	"./back.svg": "MSJp",
	"./sou.svg": "S9Ee"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7r+V";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg \.svg$
// module id = 7r+V
// module chunks = 24